// extracted by mini-css-extract-plugin
module.exports = {"sticky":"DisplaySticky_sticky__qbSa5"};